import { gql } from '@apollo/client';

export const SEARCH_BUYER_ENTITY_QUERY = gql`
  query UsersPageSearchBuyerEntity(
    $searchTerm: String!
    $size: Int = 30
    $filter: SearchFilter
  ) {
    search(
      query: { search: $searchTerm, type: buyer, size: $size, filter: $filter }
    ) {
      hits {
        entity {
          ...UsersPageBuyerEntityFragment
        }
      }
    }
  }

  fragment UsersPageBuyerEntityFragment on Buyer {
    id
    name
    referenceId
    rolesEnabled
    fullAddress
  }
`;
